enum CUSTODIAN_AGREEMENT_STATE_ENUM {
	REQUIRED = 'REQUIRED',
	OPTIONAL = 'OPTIONAL',
	SIGNED = 'SIGNED',
}

export default CUSTODIAN_AGREEMENT_STATE_ENUM;
